import { useTranslation } from "react-i18next";
import Reveal from "../Reveal";

export default function NonRider() {
  const { t } = useTranslation();
  const body = t("non_rider.body", { park: t("non_rider.park") });
  const [before, after] = body.includes(t("non_rider.park"))
    ? body.split(t("non_rider.park"))
    : [body, ""];

  return (
    <section className="bg-bone-deep py-24 lg:py-40" data-testid="non-rider-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        <Reveal className="md:col-span-5">
          <div className="aspect-[4/5] overflow-hidden bg-stone-warm">
            <img
              src="https://customer-assets.emergentagent.com/job_explore-apuseni/artifacts/s7gj8gt6_WhatsApp%20Image%202026-05-08%20at%2009.12.06.jpeg"
              alt={t("non_rider.park")}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />
          </div>
        </Reveal>

        <Reveal className="md:col-span-7" delay={150}>
          <div className="text-xs uppercase tracking-wider-3 text-terracotta mb-6 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-terracotta" />
            {t("non_rider.eyebrow")}
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-forest leading-[1.04]">
            {t("non_rider.title_a")} <span className="italic">{t("non_rider.title_b")}</span>.
          </h2>
          <p className="mt-8 text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl">
            {before}
            <span className="text-forest">{t("non_rider.park")}</span>
            {after}
          </p>
          <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
            {[1,2,3,4].map(n => (
              <li key={n} className="flex items-start gap-3">
                <span className="text-terracotta">—</span>{t(`non_rider.list_${n}`)}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
